/*
* Collection Sort Option Sort
* @param {object} opts
*/
function collectionSortOptionSort(opts) {
  const config = {
    dom: {
      sortBlock: 'sortBlock',
      sortOptions: 'js-sort-option',
      sortOptionList: 'js-sort-options-list',
    },
  };

  const c = __.extend(config, opts);

  /**
  * Init
  */
  function init() {
    const $sortBlock = document.getElementById(c.dom.sortBlock);
    const { metaSortArray } = $sortBlock.dataset;
    const $metaSortArrayDecoded = atob(metaSortArray);
    const $sortOptions = $sortBlock.querySelectorAll(`.${c.dom.sortOptions}`);

    if (!$metaSortArrayDecoded || !$sortOptions) return;

    const $optionsArray = Array.from($sortOptions);

    $optionsArray.sort((a, b) => {
      const optionA = a.getAttribute('data-sort-option');
      const optionB = b.getAttribute('data-sort-option');
      return $metaSortArrayDecoded.indexOf(optionA) - $metaSortArrayDecoded.indexOf(optionB);
    });

    // Remove existing list items from the DOM
    $sortOptions.forEach((item) => item.parentNode.removeChild(item));

    // Append sorted list items back to the list
    const list = $sortBlock.querySelector(`.${c.dom.sortOptionList}`);
    $optionsArray.forEach((item) => list.appendChild(item));
  }

  init();
}

export default collectionSortOptionSort;
